import { CONFIG } from "~/config";
import { node } from "~/util/dom";
import { _ } from "~/i18n";
import { ROUTE_CONST } from "~/route/const";
import Scene from "~/scene";
import createSDSIcon from "./icon";
import { ROUTE_PLAN_ADD } from "./sds-compatible-icons";

interface IOptions {
	poi: any;
	routeBtnCb?: (event: MouseEvent) => void;
}

interface IOptionsPlace {
	item: any;
	routeBtnCb?: (event: MouseEvent) => void;
	url: string;
	showParentInfo: boolean;
}

interface IMarkerInfo {
	info: HTMLSpanElement;
	buttonPart: HTMLSpanElement;
	seperatorPart: HTMLSpanElement;
}

function getFuel(poi: any): string {
	if (!poi.extend?.fuel) {
		return null;
	}

	const data = poi.extend.fuel.label ? poi.extend.fuel.value : poi.extend.fuel as any;
	let line = "";

	for (let index = 0; index < data.length && index < 2; index++) {
		// chtelo by prozkoumat, zda by proste jen nestacilo udelat data[i].id > 0 && data[i].id < 5
		if ([1, 2, 3, 4].indexOf(data[index].id) === -1) {
			continue;
		}

		const span = node("span", {
			innerHTML: data[index].price,
			className: `type-${data[index].id}`,
		});

		line += span.outerHTML;
	}

	return line;
}

function getAddress(poi: any) {
	let address = "";

	if (poi.multiTitle && Array.isArray(poi.multiTitle) && poi.multiTitle.length) {
		address = poi.multiTitle.slice(1).join(", ");
	} else if (poi.address && Array.isArray(poi.address)) {
		address = poi.address.join(", ");
	}

	return address;
}

/**
 * vytvoreni elementu pro kartu nad markerem, pouziva se pro markery hledani a pro marker detailu
 */
export function createMarkerInfo({
	poi = {},
	routeBtnCb = null,
}: IOptions): IMarkerInfo {
	const infoPart = node("a", {
		className: "info-part",
		href: `${CONFIG.mapyURL}/?source=${poi.source}&id=${poi.id}`,
	});
	const title = node("h5", {}, poi.title);

	infoPart.appendChild(title);

	const fuel = getFuel(poi);
	const address = getAddress(poi);

	if (!fuel && address) {
		infoPart.appendChild(node("p", { className: "address" }, address));
	}

	if (poi.extend && poi.extend.opening) {
		const actualState = poi.extend.opening.actualState;
		const actual = poi.extend.opening.actual;
		const msg = poi.extend.opening.msg; //getOpeningText(poi.extend.opening);
		const holiday = poi.extend.opening.holiday;

		let openingTxt = (actualState
			? `<span class="opening-state ${actualState.replace(/[A-Z]/u, match => `-${match.toLowerCase()}`)}"> ${poi.extend.opening.actualStateCaption}</span>`
			: poi.extend.opening.label)
				+ (actual ? ` - ${actual}` : "")
				+ (msg || holiday ? "<span class=\"holiday\">*</span>" : "");

		if ("msg" in poi.extend.opening && !poi.extend.opening.seasons.length) {
			// eslint-disable-next-line prefer-template
			openingTxt = (actualState ? `<span class="opening-state ${actualState.replace(/[A-Z]/u, match => `-${match.toLowerCase()}`)}"> ${poi.extend.opening.actualStateCaption}</span>` : poi.extend.opening.label)
				+ " - "
				+ _("detail.content.opening.seeDetail") + "<span class=\"holiday\">*</span>";
		}

		const openingEl = node("p", { innerHTML: openingTxt });

		if (msg || holiday) {
			openingEl.setAttribute("title", (msg || "") + (msg && holiday ? "\n" : "") + (holiday || ""));
		}

		infoPart.appendChild(openingEl);
	}

	if (fuel) {
		infoPart.appendChild(node("p", { className: "fuel", innerHTML: fuel }));
	}

	if (poi.inactive) {
		infoPart.appendChild(node("p", { className: "inactive", textContent: poi.temporarilyClosed ? _("detail.content.closed.temporarilyClosed") : _("detail.content.closed.title") }));
	}

	const seperatorPart = node("span", { className: "separator-part" });
	const innerSeperatorPart = node("span", { className: "separator" });
	const buttonPart = node("button", { type: "button", className: "button-part" });

	seperatorPart.appendChild(innerSeperatorPart);
	buttonPart.appendChild(createSDSIcon({
		symbol: ROUTE_PLAN_ADD,
	}));
	routeBtnCb && buttonPart.addEventListener("click", routeBtnCb);

	return {
		info: infoPart,
		buttonPart,
		seperatorPart,
	};
}

/**
 * vytvoreni elementu pro kartu nad markerem, pouziva se pro markery v moje mapy
 */
export function createMarkerInfoPlace({
	item,
	routeBtnCb,
	url,
	showParentInfo = false,
}: IOptionsPlace): IMarkerInfo {
	const infoPart = node("a", {
		className: "info-part",
		href: url,
	});
	const title = node("h5", {}, item.usertitle || item.title);

	infoPart.appendChild(title);

	if (item.subtitle) {
		infoPart.appendChild(node("p", { className: "address" }, item.subtitle));
	}

	if (showParentInfo && item.parent_name) {
		infoPart.appendChild(node("p", { className: "parent-info" }, _("mymap.marker.alwaysOnMap.parent", { parentName: item.parent_name })));
	}

	const seperatorPart = node("span", { className: "separator-part" });
	const innerSeperatorPart = node("span", { className: "separator" });
	const buttonPart = node("button", { type: "button", className: "button-part" });

	seperatorPart.appendChild(innerSeperatorPart);
	buttonPart.appendChild(createSDSIcon({
		symbol: ROUTE_PLAN_ADD,
	}));

	if (routeBtnCb) {
		buttonPart.addEventListener("click", routeBtnCb);
	}

	return {
		info: infoPart,
		buttonPart,
		seperatorPart,
	};
}


export function setFavoritePopupCont({
	card,
	item,
	opts = {},
	showParentInfo = false,
	onCardRemove = () => {},
}: {
	card: any;
	item: any;
	opts?: { hrefUrl?: string; cardClick?: () => void; };
	showParentInfo: boolean;
	onCardRemove?: () => void;
}) {
	/* eslint-disable */
	// obsah
	const markerInfo = createMarkerInfoPlace({
		item,
		routeBtnCb: item.type === "entity" || item.type === "point" ? async () => {
			//FIXME pokud je otevreny imageuploader ma to tak zustat
			if (Mapy.getComponent("imageUploader").isActive()) {
				return;
			}

			onCardRemove();

			const route = Mapy.getComponent("route");

			if (!Mapy.CML.state.route?.items?.length) {
				Mapy.CML.state = {
					route: {
						params: {
							criterion: item.source === "pubt" ? 200 : 111,
							type: item.source === "pubt" ? ROUTE_CONST.TYPE_PUBT : ROUTE_CONST.TYPE_CAR,
						},
					},
				};
			}

			await route.addItem({
				source: item.type === "point" ? "coor" : item.source,
				position: Mapy.getComponent("route").isActive() ? ROUTE_CONST.position.start : ROUTE_CONST.position.end,
				id: item.type === "point" ? `${item.mark.lon},${item.mark.lat}` : item.source_id,
				name: item.title,
				coords: Scene.coordsFromWGS84(item.mark.lon, item.mark.lat),
				desc: item.subtitle,
				...item.usertitle ? { usertitle: item.usertitle } : {},
				favoriteId: item.id,
				..."poi_type_id" in item ? {typeId: item.poi_type_id } : {},
			});

			!CONFIG.inFrame && Mapy.getComponent("history").save();
		} : null,
		url: opts.hrefUrl || `${CONFIG.mapyURL}/?dim=${item.id}`,
		showParentInfo,
	});
	var infoPart = markerInfo.info;

	// click eventy
	infoPart.addEventListener("click", e => {
		onCardRemove();

		if (!Mapy.Util.linkToNewWindow(e)) {
			e.preventDefault();

			opts.cardClick && opts.cardClick();
		}
	});

	const cardBody = card.getBody();
	Mapy.Util.clear(cardBody);
	cardBody.appendChild(infoPart);

	if (item.type === "entity" || item.type === "point") {
		cardBody.appendChild(markerInfo.seperatorPart);
		cardBody.appendChild(markerInfo.buttonPart);
	}
}
